// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"7b2f6170","239":"a2e384cf","294":"2431c3f7","328":"0b68b772","389":"cd397937","453":"1559336e","455":"b58a75b4","549":"61661484","770":"bf7db355","977":"3e7f084f"}[chunkId] + ".chunk.js";
};